import type {
  ApiBlock,
  BlockType,
} from '@backmarket/http-api/src/api-specs-content/models/block'

const FULL_WIDTH_BLOCKS: BlockType[] = [
  'Carousel',
  'Faq',
  'SectionBanner',
  'TradeInFooterLinks',
] as const

/**
 * Full width on mobile screens
 * Fixed width on desktop screens
 *
 */
const ADAPTIVE_WIDTH_BLOCKS: BlockType[] = ['EmailCollector'] as const

const PADDED_FULL_WIDTH_BLOCKS: BlockType[] = ['RichText'] as const

const NARROW_BLOCKS: BlockType[] = [
  'EmbeddedYoutubeVideo',
  'Buttons',
  'Media',
  'Categories',
] as const

function isNarrow(block: ApiBlock) {
  return NARROW_BLOCKS.includes(block.type)
}

function isFullWidthWithPadding(block: ApiBlock) {
  return PADDED_FULL_WIDTH_BLOCKS.includes(block.type)
}

export function isFullWidth(block: ApiBlock) {
  if (block.type === 'ModularCardsCarousel') {
    return block.props.desktopLayout === 'carousel' && !!block.props.fitToScreen
  }

  return FULL_WIDTH_BLOCKS.includes(block.type)
}

function isLarge(block: ApiBlock) {
  return (
    !isNarrow(block) && !isFullWidth(block) && !isFullWidthWithPadding(block)
  )
}

export function getBlockWidth(
  block: ApiBlock,
): 'full-width' | 'adaptive' | 'fixed' {
  const blockType = block.type

  if (isFullWidth(block)) {
    return 'full-width'
  }

  if (ADAPTIVE_WIDTH_BLOCKS.includes(blockType)) {
    return 'adaptive'
  }

  return 'fixed'
}

export function getDimensionProperties(block: ApiBlock) {
  return {
    hasPadding: !isFullWidth(block),
    isNarrow: isNarrow(block),
    isLarge: isLarge(block),
  }
}
